/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { ListItem } from '../../../../apiServices/ListsService';
import { ProfileContentProps } from './ProfileContentProps';
import Card, { CardList } from '../../../components/card/Card';
import { ManagedCollapsibleCardInput } from '../../../components/card/CollapsibleCard';
import ContentWrapper from '../../../components/ContentWrapper';

interface Props extends ProfileContentProps {
  intl: any;
  bloodTypes: ListItem[];
  requestInitialData(): void;
}

class ProfileBloodType extends React.Component<Props, {}> {
  render() {
    const { bloodTypes, profileData: { blood_type_id } } = this.props;
    const selectedBloodType = blood_type_id && bloodTypes.filter(b => b.id === blood_type_id)[0]

    return (
      <ContentWrapper>
        <Card>
          <ManagedCollapsibleCardInput
            title={<FormattedMessage id="profile.bloodType.field.label" />}
            collapsedContent={blood_type_id && <FormattedMessage id={selectedBloodType.key} />}
            isCollapsible={!!blood_type_id}
            defaultCollapsed={!!blood_type_id}
          >
            {
              ({ collapseList }) => (
                <ul>
                  {
                    bloodTypes.map(bloodType => (
                      <li key={bloodType.id}>
                        <CardList.SelectableRow
                          isSelected={bloodType.id === blood_type_id}
                          onClick={() => {
                            collapseList();
                            this.selectBloodType(bloodType);
                          }}
                        >
                          <FormattedMessage id={bloodType.key}/>
                        </CardList.SelectableRow>
                      </li>
                    ))
                  }
                </ul>
              )
            }
          </ManagedCollapsibleCardInput>
        </Card>
      </ContentWrapper>
    );
  }

  selectBloodType(bloodType: ListItem) {
    const { profileData, onChange } = this.props;

    onChange({
      ...profileData,
      blood_type_id: bloodType.id,
    });
  }

  UNSAFE_componentWillMount() {
    this.props.requestInitialData();
  }
}

export default injectIntl(ProfileBloodType);
